import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages, faCamera } from '@fortawesome/free-solid-svg-icons';

import { BrowserView, MobileView } from 'react-device-detect';
import Translate from '../common/Translate';

const CarUploadButtons = (props) => {
  const { setImage, questionId } = props;

  return (
    <>
      <MobileView>
        <Container fluid>
          <Row className="my-4">
            <Col className="text-center">
              <label
                htmlFor="upload_gallery"
                className="button-camera circle"
                data-test={`${questionId}-uploadGallery-label`}
              >
                <FontAwesomeIcon icon={faImages} />
                <input
                  type="file"
                  id="upload_gallery"
                  accept="image/*"
                  onChange={setImage}
                  data-cy="upload_gallery"
                  data-test={`${questionId}-uploadGallery-inputFile`}
                />
              </label>
              <Translate code="photo_gallery" />
            </Col>

            <Col className="text-center">
              <label
                htmlFor="upload_camera"
                className="button-camera circle"
                data-test={`${questionId}-uploadCamera-label`}
              >
                <FontAwesomeIcon icon={faCamera} />
                <input
                  type="file"
                  id="upload_camera"
                  accept="image/*"
                  capture="camera"
                  onChange={setImage}
                  data-cy="upload_camera"
                  data-test={`${questionId}-uploadCamera-inputFile`}
                />
              </label>
              <Translate code="camera" />
            </Col>
          </Row>
        </Container>
      </MobileView>

      <BrowserView>
        <Container fluid>
          <Row className="my-4">
            <Col className="text-center">
              <label
                htmlFor="upload_gallery"
                className="button-camera circle"
                data-test={`${questionId}-uploadGallery-label`}
              >
                <FontAwesomeIcon icon={faImages} />
                <input
                  type="file"
                  id="upload_gallery"
                  accept="image/*"
                  onChange={setImage}
                  data-cy="upload_gallery"
                  data-test={`${questionId}-uploadGallery-inputFile`}
                />
              </label>
              <Translate code="photo_gallery" />
            </Col>
          </Row>
        </Container>
      </BrowserView>
    </>
  );
};

export default CarUploadButtons;

CarUploadButtons.propTypes = {
  setImage: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
};
